import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';

@Injectable()
export class Cookie {
  public getCookie(name) {
    if (document.cookie !== '') {
      const cookies = document.cookie.split(/; */);

      for (let i = 0; i < cookies.length; i++) {
        const cookieName = cookies[i].split('=')[0];
        const cookieVal = cookies[i].split('=')[1];
        if (cookieName === decodeURIComponent(name)) {
          return decodeURIComponent(cookieVal);
        }
      }
    }
  }

  public setCookie(name, val, days = null, path = null, domain = null, secure = null) {
    if (!navigator.cookieEnabled) {
      return;
    }
    const cookieName = encodeURIComponent(name);
    const cookieVal = encodeURIComponent(val);
    let cookieText = cookieName + '=' + cookieVal;
    if (typeof days === 'number') {
      const data = new Date();
      data.setTime(data.getTime() + (days * 24 * 60 * 60 * 1000));
      cookieText += '; expires=' + data.toUTCString();
    } else if (days !== null) {
      cookieText += '; expires=' + days;
    }
    if (path) {
      cookieText += '; path=' + path;
    }

    if (domain && location.hostname !== 'localhost') {
      cookieText += '; domain=' + domain;
    }
    if (secure) {
      cookieText += '; secure';
    }
    document.cookie = cookieText;
  }

  public removeCookie(name) {
      const cookieName = encodeURIComponent(name);
      document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;domain=' + environment.cookiesHost + ';';
  }
}
